import { useMemo } from 'react';
import type { SponsorDirectory } from '@conference/shared';
import PartnerCard from './PartnerCard';

export default function SponsorDirectoryPanel({ directory, onOpen }: {
  directory: SponsorDirectory;
  onOpen: (id: string) => void;
}) {
  const groups = useMemo(() => directory.tiers.map((tier) => ({
    tier,
    partners: directory.sponsors.filter((partner) => partner.sponsorship_tier_id === tier.id),
  })).filter(({ partners }) => partners.length > 0), [directory]);

  return <div className="space-y-6">{groups.map(({ tier, partners }) => (
    <section key={tier.id}>
      <h2 className="mb-3 text-sm font-semibold" style={{ color: 'var(--app-text)' }}>{tier.name}</h2>
      <div className="space-y-2">{partners.map((partner) => (
        <PartnerCard key={partner.id} partner={partner} onOpen={onOpen} />
      ))}</div>
    </section>
  ))}</div>;
}
